<template>
  <component
    :is="`wa-${props.type}`"
    v-if="isUsable"
    ref="el"
    :open="props.open"
    v-bind="$attrs"
    light-dismiss
    @wa-request-close="onRequestClose"
  >
    <slot />
  </component>
</template>

<script setup>
import '@awesome.me/webawesome/dist/components/drawer/drawer.js'
import '@awesome.me/webawesome/dist/components/dialog/dialog.js'

import { ref, computed } from 'vue'

const emit = defineEmits(['request-close'])

const props = defineProps({
  type: {
    type: String,
    default: 'drawer'
  },
  open: {
    type: Boolean,
    default: false
  },
  closingBlocked: {
    type: Boolean,
    default: false
  }
})

const usableTypes = ['drawer', 'dialog']
const isUsable = computed(() => usableTypes.includes(props.type))
const el = ref()

function onRequestClose(event) {
  if (props.closingBlocked) {
    event.preventDefault()
  } else if (event.target === el.value) {
    emit('request-close', event)
  }
}
</script>
